<template>
	<CCard>
		<CCardHeader>
			<h5>Sélectionnez le colis concerné (Optionnel)</h5>
		</CCardHeader>
		<CCardBody>
			<GDataTableRemote
				ref="mainTable"
				:remote-url="queryUrl"
				:fields="fields"
				:items-per-page="10"
				hover
				striped
				sorter
				columnFilter
				pagination>
				<template #reshipment="{ item }">
					<td>
						<template v-if="item.reshippedOrder">
							<router-link :to="`/orders/${item.reshippedOrder['@id'].split('/').pop()}/edit`">
								Colis réexpédié
							</router-link>
						</template>
						<template v-else-if="item.originalOrder">
							<router-link :to="`/orders/${item.originalOrder['@id'].split('/').pop()}/edit`">
								Colis d'origine
							</router-link>
						</template>
						<template v-else>
							<CIcon name="cil-ban" />
						</template>
					</td>
				</template>

				<template #product="{ item }">
					<td>
						{{ item.product ? item.product.name : '' }}
					</td>
				</template>

				<template #search_receiver="{ item }">
					<td>
						<template v-if="item && item.receiverAddress">
							{{
								`${item.receiverAddress.firstName} ${item.receiverAddress.lastName} | ${item.receiverAddress.address}, ${item.receiverAddress.postalCode} ${item.receiverAddress.city}`
							}}
						</template>
						<template v-else>
							<CIcon name="cil-ban" />
						</template>
					</td>
				</template>

				<template #actions="{ item }">
					<td v-if="ticket.orderItem['@id'] === item['@id']">
						<CButton color="primary" disabled> Sélectionné </CButton>
					</td>
					<td v-else>
						<GLoadingButton
							:loading="loading"
							color="primary"
							@click.prevent="updatePackage(item)"
							label="Sélectionner" />
					</td>
				</template>
			</GDataTableRemote>
			<slot name="submit"></slot>
		</CCardBody>
	</CCard>
</template>

<script>
	import GDataTableRemote from '../../../../../components/ghostlexly-components/GDataTableRemote';
	import GLoadingButton from '../../../../../components/ghostlexly-components/GLoadingButton';
	export default {
		name: 'SelectPackageCard',
		components: { GLoadingButton, GDataTableRemote },
		props: {
			customer: Object,
			orderIri: String,
			ticket: Object,
		},
		computed: {
			queryUrl() {
				let base = `/api/order_items?parentOrder.owner=${this.customer['@id']}&order[id]=DESC`;

				if (this.orderIri !== undefined) {
					base += `&parentOrder.id=${this.orderIri}`;
				}

				return base;
			},
		},
		data() {
			return {
				fields: [
					{ key: 'id', label: '#' },
					{ key: 'product', label: 'Type de colis', sorter: false },
					{ key: 'reshipment', label: 'Réexpédition', sorter: false, filter: false },
					{ key: 'deliveryDate', label: 'Date de livraison', type: 'daterange' },
					{ key: 'search_receiver', label: 'Destinataire' },
					{ key: 'actions', label: 'Actions', filter: false },
				],
				loading: false,
			};
		},
		methods: {
			refresh() {
				this.$refs.mainTable.refresh();
			},

			updatePackage(item) {
				this.loading = true;

				this.$axios
					.patch(this.ticket['@id'], {
						orderItem: item['@id'],
					})
					.then(() => {
						this.loading = false;
						this.$emit('refresh');
						this.refresh();
					})
					.catch(err => {
						this.loading = false;
						this.$toast.error(err.response.data['hydra:description']);
					});
			},
		},
	};
</script>

<style></style>
